// removed by extract-text-webpack-plugin
module.exports = {"Base":"HeaderTab__Base-2pCdX","H1":"HeaderTab__H1-2EFjC","H1--withIcon":"HeaderTab__H1--withIcon-3f-22 HeaderTab__H1-2EFjC","H2":"HeaderTab__H2-28ymQ","Icon":"HeaderTab__Icon-2ULDh","Icon--icedCoffee":"HeaderTab__Icon--icedCoffee-130ZL HeaderTab__Icon-2ULDh","Icon--cup":"HeaderTab__Icon--cup-2puUx HeaderTab__Icon-2ULDh","Icon--pot":"HeaderTab__Icon--pot-qNKLF HeaderTab__Icon-2ULDh","Icon--talk-bubble":"HeaderTab__Icon--talk-bubble-20Swr HeaderTab__Icon-2ULDh","Icon--camera":"HeaderTab__Icon--camera--IPp8 HeaderTab__Icon-2ULDh","Icon--star":"HeaderTab__Icon--star-1_426 HeaderTab__Icon-2ULDh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/HeaderTab/HeaderTab.css
 ** module id = 630
 ** module chunks = 0
 **/